import { SectionHead } from "./SectionHead";

const PILLARS = [
  ["Leadership", "World-class speakers — and the people making the decisions."],
  ["Building", "Live demonstrations of what can actually be built with AI."],
  ["Impact", "Real conversations about business, productivity, policy and society."],
];

export const WhatItIs = () => (
  <section className="ns-sec pp" id="what" data-testid="ns-what">
    <div className="ns-wrap">
      <SectionHead nr="01" label="What it is" right="13 April 2027 · Grieghallen, Bergen" />
      <div className="ns-grid">
        <div className="g-1-9">
          <h2 className="ns-h2" data-rv data-testid="ns-what-h">Where Norway goes from AI ambition to AI action.</h2>
        </div>
        <div className="g-1-6">
          <p className="ns-lede" data-rv data-testid="ns-what-lead">
            <b>Norwegian AI Summit</b> brings together 700 of Norway's decision-makers, builders, investors and policymakers for one focused day in Bergen. One room. One programme. No parallel tracks.
          </p>
          <ol className="ns-ledger mt-l" data-rv style={{ "--d": ".15s" }} data-testid="ns-what-pillars">
            {PILLARS.map(([t, d], i) => (
              <li key={t}><span className="k">0{i + 1}</span><span className="t">{t}</span><span className="d">{d}</span></li>
            ))}
          </ol>
        </div>
        <div className="g-8-12">
          <div data-rv="wipe" style={{ "--d": ".2s" }}>
            <figure className="ns-fig ns-what-fig" data-testid="ns-what-photo">
              <img src="/images/what-room-v4.webp" alt="The room, seen from the stage" loading="lazy" />
              <span className="cap">The room · concept visualisation</span>
            </figure>
          </div>
          <p className="ns-what-not" data-rv style={{ "--d": ".35s" }} data-testid="ns-what-not">
            Not a trade show. Not a sales stage.
            <b>One room. One programme. The people shaping Norway's AI future.</b>
          </p>
        </div>
      </div>
    </div>
  </section>
);
